export const DEPRECATED_FAVOURITES_LOCAL_STORAGE_KEY = "SRF.meteoFavourites";
export const RECENT_LOCATIONS_LOCAL_STORAGE_KEY = "srf:meteo:recentLocations";
export const ANIMATED_WEATHER_ICONS = "srf:meteo:animatedWeatherIconsEnabled";
